import * as queryString from 'query-string';
import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';
import { SigninErrorPage } from '~src/authentication/components/SigninErrorPage';

import { Helpers } from '../../../ts/helpers/Helpers';
import { RouterError } from '../RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';
import { LoginUrlsWrapper } from './LoginUrls';
import { SignInLogo } from './SignInLogo';

export interface SpaceRouteParams {
  readonly errorCode: string;
}
export interface SigninErrorRouteComponentProps extends RouteComponentProps<SpaceRouteParams> { }

export interface LoginErrorProviderProps {
  readonly isSessionMultiSite: boolean;
  readonly urls: SpacesSiteUrls;
}

export class LoginErrorProvider extends React.Component<LoginErrorProviderProps> {
  public render() {
    return (
      <DefaultServerTitleWrapper>
        <div className="tb-error-box tb-error-no-site">
          <SignInLogo />
          <Route exact path={LoginUrlsWrapper.getInstance().signinErorrCodePath(':errorCode')} render={this.errorCodeProvider()} />
          <Route exact path={LoginUrlsWrapper.getInstance().signinAuthErorrPath(':errorCode')} render={this.authErrorProvider()} />
        </div>
      </DefaultServerTitleWrapper>
    );
  }

  private authErrorProvider = (): (props: SigninErrorRouteComponentProps) => JSX.Element => {
    return (props: SigninErrorRouteComponentProps): JSX.Element => {
      const queryValues = queryString.parse(props.location.search);
      return(
        <div>
          <SigninErrorPage
            errorCode={props.match.params.errorCode}
            redirectPath={queryValues['redirectPath']?? '/'} />
        </div>
      );
    };
  }

  private errorCodeProvider = (): (props: SigninErrorRouteComponentProps) => JSX.Element => {
    return (props: SigninErrorRouteComponentProps): JSX.Element => {
      const queryValues = queryString.parse(props.location.search);
      const errorCode = props.match.params.errorCode;
      const fromSiteSwitch = Helpers.BooleanQueryParamRegex.test(queryValues['fromSiteSwitch']);
      if (fromSiteSwitch) {
        if (this.props.isSessionMultiSite) {
          return <RouterError code={errorCode} errorType="no-site-multi-site-user" urls={this.props.urls}/>;
        } else {
          return <RouterError code={errorCode} errorType="no-site-single-site-user" urls={this.props.urls}/>;
        }
      } else {
        return <RouterError code={errorCode} errorType="code" urls={this.props.urls}/>;
      }
    };
  }
}
